import { render, staticRenderFns } from "./StarRatingDisplay.vue?vue&type=template&id=1df78ba1&scoped=true"
import script from "./StarRatingDisplay.vue?vue&type=script&lang=js"
export * from "./StarRatingDisplay.vue?vue&type=script&lang=js"
import style0 from "./StarRatingDisplay.vue?vue&type=style&index=0&id=1df78ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df78ba1",
  null
  
)

export default component.exports